module.exports = __webpack_public_path__ + "img/Serenitas.b276e947.png";